<template>
  <div v-if="!!firstItem">
    <div
      v-if="!!message.content.textMain"
      class="products-list-header">
      {{ message.content.textMain }}
    </div>
    <products-item
      :item="firstItem"
      :message="message"
      :show-badge="true"
      @product-clicked="$emit('product-clicked', $event)"
      @product-added-to-cart="$emit('product-added-to-cart', $event)"
      @product-info-clicked="$emit('product-info-clicked', $event)"
      @attribute-matching-list-expanded="$emit('attribute-matching-list-expanded', $event)"
    />
    <div
      v-if="!!message.content.textOther && otherItems.length > 0"
      class="products-list-header">
      {{ message.content.textOther }}
    </div>
    <products-item
      v-for="(item, index) in otherItems"
      :key="index"
      :item="item"
      :message="message"
      @product-clicked="$emit('product-clicked', $event)"
      @product-added-to-cart="$emit('product-added-to-cart', $event)"
      @product-info-clicked="$emit('product-info-clicked', $event)"
      @attribute-matching-list-expanded="$emit('attribute-matching-list-expanded', $event)"
    />
  </div>
</template>

<script>
// @flow

import { ChatchampMessageItem } from '@chatchamp/chatchamp-types'

import ProductsItem from '../ProductsItem/ProductsItem.vue'

export default {
  components: {
    ProductsItem
  },
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    firstItem (): ChatchampMessageItem {
      return this.message.content.elements[0]
    },
    otherItems (): Array<ChatchampMessageItem> {
      return this.message.content.elements.slice(1)
    }
  }
}
</script>

<style src="./products-list.scss" />
